import styled, { css } from 'styled-components';
import { ReactComponent as EditIcon } from '../../../../../../assets/icons/v2/edit-blue.svg';
import { ReactComponent as DeleteIcon } from '../../../../../../assets/icons/v2/trash.svg';

const ChipContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 5px;
  padding: 4px;
`;
const ActionsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 15px;
`;

const iconStyles = css`
  width: 16px;
`;

const StyledEditIcon = styled(EditIcon)`
  ${iconStyles};
`;

const StyledDeleteIcon = styled(DeleteIcon)`
  ${iconStyles};
`;

export {
  ChipContainer,
  ActionsContainer,
  StyledEditIcon,
  StyledDeleteIcon,
};
